module.exports = __webpack_public_path__ + "img/prueba3.f33df980.png";